//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FlowSteps from '@/components/common_flowSteps.vue'
import FlexTable from '@/components/common_flexTable.vue'
import PageBtns from '@/components/common_pageBtns.vue'
import PageScan from '@/components/common_pageScan.vue'
export default {
  name: '',
  components: { FlowSteps, FlexTable, PageBtns, PageScan },
  data () {
    return {
      flowConfig: {
        bg: '#fff',
        padding: '15px 40px',
        size: '30px',
        numberSize: '18px',
        textSize: '',
        textTop: '30px',
        lineWidth: '3px',
        list: [
          {number:1, text:'创建入库单', isDone:true},
          {number:2, text:'入库扫码', isActive:true, isDone:false},
          {number:3, text:'入库结束', isDone:false},
        ]
      },
      tableConfig1: {
        hideVborder: true,
        thBg: '#fff',
        hideNoData: true,
        thList: [
          {text: '序号', width: '30%'},
          {text: '订单数量', width: '30%'},
          {text: '扫码数量', flex: '1'},
        ],
        trList: [ ]
      },
      tableConfig2: {
        hideVborder: true,
        thBg: '#fff',
        hideNoData: true,
        thList: [
          {text: '序号', width: '30%'},
          {text: '扫码序列', width: '30%'},
          {text: '类型', flex: '1'},
        ],
        trList: [ ]
      },
      btnConfig: {
        absolute: true,
        bottom: '10px',
        list: [ {text:'测试', width: '100%',type: 'primary', action: () => this.onScan() } ],
      },
      scanConfig: {
        btnL: {text: '返回', action: () => this.$router.go(-1)},
        desc: '扫一扫急速入库'
      }
    }
  },
  props: [],
  computed: {},
  methods: {}
}
